import React, { useEffect, useState } from 'react';
import CustomSelect from '../../../../../components/common/SelectField';
import { MenuItem } from '@mui/material';
import { TableInput } from '../../../../../components/common';
import { RenderTable } from '../../../../../components/ui';
import { Table } from '../../../../../components/ui/renderTable/styled';
import axios from 'axios';

const RejectionTable = (props: any) => {
  const { process, isView, reasonType } = props;
  const [render, setRender] = useState(false);
  const [defects, setDefects] = useState([]);

  useEffect(() => {
    axios
      .get('/api/defectRoutes/defectList/defectForAutoComplete')
      .then((res) => {
        if (res?.data) {
          setDefects(res?.data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <Table style={{ width: '80vh' }}>
      <thead>
        <tr>
          <th>S.No.</th>
          <th>Reasons</th>
          <th>Rejection Qty</th>
        </tr>
      </thead>
      <tbody>
        {reasonType === 'rejection' &&
          process?.reasons_for_rej?.map((item: any, index: number) => (
            <tr>
              <th>{index + 1}</th>
              <td style={{ minWidth: '300px', textAlign: 'center' }}>
                {isView ? (
                  item.reason
                ) : (
                  <CustomSelect
                    name="reason"
                    value={item.reason}
                    onChange={(e) => {
                      item.reason = e.target.value;
                      setRender((prev) => !prev);
                    }}
                  >
                    <MenuItem value="">None</MenuItem>
                    {defects.map((reason: any) => (
                      <MenuItem value={reason.defect_name}>
                        {reason.defect_name}
                      </MenuItem>
                    ))}
                  </CustomSelect>
                )}
              </td>
              <td style={{ minWidth: '100px', textAlign: 'center' }}>
                <TableInput
                  isView={isView}
                  name="rej_qty"
                  key="rej_qty"
                  type="number"
                  value={item.rej_qty}
                  onChange={(e) => {
                    item.rej_qty = e.target.value;
                    setRender((prev) => !prev);
                  }}
                />
              </td>
            </tr>
          ))}
        {reasonType === 'production' &&
          process?.reasons_for_less_prod?.map((item: any, index: number) => (
            <tr>
              <th>{index + 1}</th>
              <td style={{ minWidth: '300px', textAlign: 'center' }}>
                {isView ? (
                  item.reason
                ) : (
                  <CustomSelect
                    name="reason"
                    value={item.reason}
                    onChange={(e) => {
                      item.reason = e.target.value;
                      setRender((prev) => !prev);
                    }}
                  >
                    <MenuItem value="">None</MenuItem>
                    {defects.map((reason: any) => (
                      <MenuItem value={reason.defect_name}>
                        {reason.defect_name}
                      </MenuItem>
                    ))}
                  </CustomSelect>
                )}
              </td>
              <td style={{ minWidth: '100px', textAlign: 'center' }}>
                <TableInput
                  isView={isView}
                  name="rej_qty"
                  key="rej_qty"
                  type="number"
                  value={item.rej_qty}
                  onChange={(e) => {
                    item.rej_qty = e.target.value;
                    setRender((prev) => !prev);
                  }}
                />
              </td>
            </tr>
          ))}
      </tbody>
      <tfoot>
        <tr>
          <th colSpan={2}>Total Rejection</th>
          <th>{process.prod_qty - process.accepted_qty}</th>
        </tr>
      </tfoot>
    </Table>
  );
};

export default RejectionTable;
